import { FieldError } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import getTranslatedFormErrorMessage from '_utils/getTranslatedFormErrorMessage';

const useTranslatedFormErrorMessage = (error: FieldError | undefined): null | string => {
    const { t } = useTranslation();
    return getTranslatedFormErrorMessage(error, t);
};

export default useTranslatedFormErrorMessage;
